module.exports = __webpack_public_path__ + "static/media/1.f86c3f78.png";